import { useMemo, useRef } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import Advt from './components/Advt/Advt';
import Message from './components/Message/Message';
import Vote from './components/Vote/Vote';
import { VoteCounter } from './components/VoteCounter/VoteCounter';

import { useBroadcast } from './hooks/useBroadcast';
import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';

import defaultBackground from './assets/images/bg.png';

function App() {
  const { currentMessage, messageAnimationTrigger, setDelay } = useBroadcast();
  const { currentState, isVisible, voteState, keyRef } = useVote();
  const { bg, phoneNumber, socials, title, qrCode, bgColor, voteCounter } =
    useGetParams();

  const advt_info = useMemo(
    () => ({
      qrCode: qrCode,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode]
  );

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg, bgColor]);

  // контейнер с сообщением, нужен для скролинга текста сообщения в useScrollText
  const messagesRef = useRef(null);

  return (
    <div className="app-wrapper" style={{ background }}>
      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
        nodeRef={messagesRef}>
        <SwitchTransition>
          <CSSTransition
            key={keyRef}
            addEndListener={(node, done) => {
              node.addEventListener('transitionend', done, false);
            }}
            classNames="fade-scale">
            <div className="titre-wrapper">
              {!voteState?.variants &&
                (currentState === 'S1' ||
                  currentState === 'S2' ||
                  currentState === 'S3') && (
                  <div
                    className={
                      currentState === 'S1' || currentState === 'S2'
                        ? 'grid-item--xl'
                        : 'grid-item--l'
                    }>
                    <Vote
                      advtInfo={advt_info}
                      withCircles={
                        currentState === 'S1' || currentState === 'S2'
                      }
                      withCircleGroup={
                        currentState === 'S1' || currentState === 'S2'
                      }
                      variants={voteState?.vars}
                      title={voteState?.title}
                      withResults={currentState !== 'S1'}
                    />
                  </div>
                )}

              {currentState === 'S1' && voteCounter !== 0 && (
                <div className="grid-item--s">
                  <VoteCounter
                    total={
                      voteState?.vars.reduce((acc, el) => acc + +el.count, 0) ||
                      0
                    }
                  />
                </div>
              )}

              <CSSTransition
                in={
                  currentMessage &&
                  (currentState === 'S3' || currentState === 'S4')
                }
                timeout={500}
                classNames="fade-scale"
                unmountOnExit>
                <SwitchTransition>
                  <CSSTransition
                    key={messageAnimationTrigger}
                    addEndListener={(node, done) => {
                      node.addEventListener('transitionend', done, false);
                    }}
                    classNames="fade">
                    <div
                      ref={messagesRef}
                      className={
                        currentState === 'S3'
                          ? 'titre-message grid-item--m ml-40'
                          : 'titre-message grid-item--m'
                      }>
                      <Message
                        withCircles={currentState === 'S3'}
                        message={currentMessage?.message || {}}
                        setDelay={setDelay}
                        messagesWrapper={messagesRef.current}
                      />
                    </div>
                  </CSSTransition>
                </SwitchTransition>
              </CSSTransition>

              {currentState === 'S4' && (
                <div className="cta">
                  <Advt className="titre-advt" advtInfo={advt_info} />
                </div>
              )}
            </div>
          </CSSTransition>
        </SwitchTransition>
      </CSSTransition>
      <div id="img-loader"></div>
    </div>
  );
}

export default App;
